import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import UserGroup from './icon-user-group.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <UserGroup {...validProps} />;
}
SvgComponent.iconName = 'userGroup';

/**
 * @deprecated This is a legacy icon
 */
export const UserGroupIcon = svgIconWrapper(SvgComponent);
